var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { DivTag, SpanTag, UlTag, LiTag, ImgTag } from '../../Utils/AtomicTag';
export var Comment = function (props) {
    var className = props.className, style = props.style, children = props.children, avatar = props.avatar, author = props.author, datetime = props.datetime, content = props.content, actions = props.actions;
    var CommentWrapperBox = ['mt-px-30', 'flex'];
    var avatarWrapper = ['w-px-32', 'mr-px-16'];
    var avatarString = ['h-px-32', 'w-px-32', 'rounded-full'];
    var authorContentWrapper = ['flex-1'];
    var mainWrapper = ['flex-1'];
    var authorWrapper = ['mr-px-15'];
    var contentWrapper = ['text-gray-700', 'text-sm'];
    var actionsWrapper = ['h-px-32', 'flex', 'items-center', 'text-sm'];
    var liBoxWrapper = ['mr-px-15', 'flex', 'items-center'];
    var ChildrenWrapperBox = ['ml-px-40'];
    var avatarDom = avatar ? (React.createElement(DivTag, { atomics: avatarWrapper }, typeof avatar === 'string' ? (React.createElement(ImgTag, { src: avatar, atomics: avatarString, className: "comment-avatar" })) : (avatar))) : null;
    var authorContent = (author || datetime) && (React.createElement(DivTag, { atomics: authorContentWrapper },
        author && React.createElement(SpanTag, { atomics: authorWrapper }, author),
        datetime && React.createElement("span", { className: "" }, datetime)));
    var contentDom = content ? React.createElement(DivTag, { atomics: contentWrapper }, content) : null;
    var actionsDom = actions && actions.length > 0 ? (React.createElement(UlTag, { atomics: actionsWrapper }, actions.map(function (action, index) { return (React.createElement(LiTag, { key: "action-" + index, atomics: liBoxWrapper }, action)); }))) : null;
    return (React.createElement(DivTag, { name: Comment.NAME, atomics: CommentWrapperBox, className: className, style: __assign({}, style) },
        avatarDom,
        React.createElement(DivTag, { atomics: mainWrapper },
            React.createElement(DivTag, null, authorContent),
            React.createElement(DivTag, null,
                contentDom,
                actionsDom,
                React.createElement(DivTag, null, children)))));
};
Comment.NAME = 'comment';
Comment.displayName = 'Comment';
